var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatbotBro1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 350,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M296.604 112.336C296.604 112.336 284.795 64.9739 213.304 35.1049C141.813 5.23594 77.854 32.8999 63.273 67.8999C48.692 102.9 63.973 121.8 54.243 151.69C44.513 181.58 -5.474 219.436 14.7 265.342C34.874 311.248 129.276 324.359 205.667 314.888C282.058 305.417 341.74 200.494 296.604 112.336Z",
    fill: "#28CC9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M296.604 112.336C296.604 112.336 284.795 64.9739 213.304 35.1049C141.813 5.23594 77.854 32.8999 63.273 67.8999C48.692 102.9 63.973 121.8 54.243 151.69C44.513 181.58 -5.474 219.436 14.7 265.342C34.874 311.248 129.276 324.359 205.667 314.888C282.058 305.417 341.74 200.494 296.604 112.336Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.6 74.606H52.5C50.6435 74.606 48.863 75.3435 47.5503 76.6562C46.2375 77.969 45.5 79.7494 45.5 81.606V103.306C45.5 105.162 46.2375 106.943 47.5503 108.256C48.863 109.568 50.6435 110.306 52.5 110.306H110.25L117.6 120.106V81.606C117.6 79.7494 116.863 77.969 115.55 76.6562C114.237 75.3435 112.457 74.606 110.6 74.606Z",
    fill: "#263238"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1488 98.497H56.0488V85.197H58.1488V90.888H60.5148V85.197H62.6148V98.497H60.5148V92.806H58.1488V98.497Z",
    fill: "#28CC9E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1621 85.218H66.2621V98.518H64.1621V85.218Z",
    fill: "#28CC9E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.098 85.218H76.545V87.115H74.361V98.497H72.261V87.115H70.084L70.098 85.218Z",
    fill: "#28CC9E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5414 98.497H77.4414V85.197H79.5414V90.888H81.9004V85.197H84.0004V98.497H81.9004V92.806H79.5274L79.5414 98.497Z",
    fill: "#28CC9E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6397 90.811H90.5027V92.708H87.6397V96.6H91.2447V98.497H85.5537V85.197H91.2447V87.094H87.6397V90.811Z",
    fill: "#28CC9E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8939 98.4969C96.7227 97.9712 96.6585 97.4167 96.7049 96.8659V94.7659C96.7049 93.5339 96.2919 93.0789 95.3049 93.0789H94.6049V98.4829H92.5049V85.1829H95.6549C97.8179 85.1829 98.7489 86.1909 98.7489 88.2349V89.2779C98.7489 90.6429 98.3079 91.5389 97.3489 91.9729C98.3919 92.4139 98.7489 93.4149 98.7489 94.7729V96.8239C98.711 97.3708 98.7897 97.9196 98.9799 98.4339L96.8939 98.4969ZM94.6189 87.1149V91.1959H95.4379C96.2149 91.1959 96.6909 90.8529 96.6909 89.7959V88.4799C96.6909 87.5349 96.3689 87.0799 95.6269 87.0799L94.6189 87.1149Z",
    fill: "#28CC9E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.249 90.811H105.112V92.708H102.249V96.6H105.847V98.497H100.156V85.197H105.847V87.094H102.249V90.811Z",
    fill: "#28CC9E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.408 95.557L107.142 90.755V85.218H109.242V90.755L108.976 95.557H107.408ZM109.186 96.488V98.497H107.177V96.488H109.186Z",
    fill: "#28CC9E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M208.6 75.306C208.6 75.306 206.01 74.389 205.422 76.706C204.834 79.023 208.264 79.884 208.684 79.884C209.104 79.884 209.769 79.303 209.349 77.966C208.929 76.629 208.6 75.306 208.6 75.306Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M223.3 69.6221C223.3 69.6221 223.048 72.9681 223.048 74.3051C223.048 75.6421 224.448 76.1461 225.148 76.1461C225.848 76.1461 226.156 77.7351 225.736 79.4081C225.316 81.0811 223.895 82.0821 220.465 82.0821C217.035 82.0821 214.949 80.5771 214.865 79.4921C214.781 78.4071 215.614 73.7171 217.042 72.4921C218.47 71.2671 223.3 69.6221 223.3 69.6221Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M210.777 79.9049V81.1999C210.778 81.4037 210.837 81.603 210.947 81.7743C211.058 81.9455 211.215 82.0815 211.4 82.1659C212.001 82.4201 212.64 82.5738 213.29 82.6209C214.601 82.6212 215.896 82.3344 217.084 81.7809C217.249 81.7108 217.389 81.5937 217.487 81.4443C217.586 81.2949 217.638 81.1198 217.637 80.9409V79.5899C217.636 79.5075 217.614 79.4268 217.574 79.3547C217.534 79.2827 217.477 79.2215 217.408 79.1766C217.339 79.1317 217.26 79.1045 217.178 79.0972C217.096 79.0899 217.013 79.1029 216.937 79.1349L216.664 79.2749C216.664 79.2749 212.534 79.7999 210.777 79.9049Z",
    fill: "#28CC9E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M208.944 68.9501C208.486 70.7889 208.177 72.6616 208.02 74.5501C207.768 77.6441 208.02 80.4861 209.273 80.5701C210.132 80.5716 210.975 80.3289 211.702 79.8701C211.702 79.8701 214.628 80.2061 215.629 79.7091L216.637 79.2051L217.386 74.3051C217.386 74.3051 217.47 66.6961 216.049 66.1921C214.628 65.6881 208.944 68.9501 208.944 68.9501Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M211.197 72.3801L210.532 74.1371C210.532 74.1371 209.188 74.4731 209.356 75.1381C209.524 75.8031 210.413 75.7051 210.413 75.7051",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M213.347 73.143C213.214 73.507 212.941 73.745 212.752 73.675C212.563 73.605 212.507 73.248 212.647 72.877C212.787 72.506 213.053 72.268 213.249 72.345C213.445 72.422 213.501 72.8 213.347 73.143Z",
    fill: "#263238"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M210.196 72.296C210.056 72.667 209.79 72.905 209.594 72.835C209.398 72.765 209.356 72.401 209.489 72.037C209.622 71.673 209.895 71.428 210.091 71.498C210.287 71.568 210.329 71.932 210.196 72.296Z",
    fill: "#263238"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M212.702 70.7911C212.702 70.7911 214.291 70.3711 214.459 71.8831",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M210.616 70.3711C210.616 70.3711 209.216 69.8741 208.775 71.0711",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M211.701 79.905L213.955 78.988",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M210 65.0999C210 65.0999 207.326 61.9219 205.317 64.2599C203.308 66.5979 203.917 70.1189 207.494 70.2869C211.071 70.4549 215.103 66.9409 215.103 66.9409C215.103 66.9409 214.683 71.5399 215.684 73.1289C216.685 74.7179 217.441 75.8029 217.441 75.8029C217.441 75.8029 218.841 76.7199 221.207 74.8859C223.573 73.0519 224.133 68.5859 222.46 65.5969C220.787 62.6079 217.861 60.9139 214.347 62.0969C210.833 63.2799 210 65.0999 210 65.0999Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M215.796 75.726C215.796 75.726 218.806 72.968 218.806 74.557C218.806 76.146 217.406 77.567 216.3 77.231",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M215.796 75.726C215.796 75.726 218.806 72.968 218.806 74.557C218.806 76.146 217.406 77.567 216.3 77.231",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M209.356 77C209.752 77.2848 210.227 77.4381 210.714 77.4381C211.202 77.4381 211.677 77.2848 212.072 77",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M224.89 82.2855C230.235 76.5974 229.957 67.6532 224.269 62.3081C218.581 56.9629 209.637 57.2408 204.292 62.9289C198.946 68.6169 199.224 77.5611 204.912 82.9063C210.6 88.2515 219.545 87.9735 224.89 82.2855Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M310.768 187.577C318.802 185.699 323.792 177.664 321.913 169.631C320.035 161.597 312 156.607 303.967 158.486C295.933 160.364 290.944 168.399 292.822 176.432C294.7 184.466 302.735 189.455 310.768 187.577Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M312.466 177.436C312.466 178.419 312.175 179.38 311.629 180.197C311.083 181.015 310.306 181.652 309.398 182.028C308.49 182.404 307.491 182.502 306.527 182.311C305.563 182.119 304.677 181.645 303.982 180.95C303.287 180.255 302.814 179.37 302.622 178.406C302.43 177.442 302.529 176.442 302.905 175.534C303.281 174.626 303.918 173.85 304.735 173.304C305.552 172.758 306.513 172.466 307.496 172.466C308.814 172.466 310.079 172.99 311.011 173.922C311.943 174.854 312.466 176.118 312.466 177.436Z",
    fill: "#28CC9E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M314.601 180.747C315.673 179.409 316.345 177.795 316.54 176.091C316.735 174.388 316.445 172.664 315.703 171.118C314.961 169.572 313.797 168.268 312.345 167.354C310.894 166.441 309.214 165.957 307.499 165.957C305.785 165.957 304.105 166.441 302.653 167.354C301.202 168.268 300.038 169.572 299.296 171.118C298.554 172.664 298.263 174.388 298.458 176.091C298.653 177.795 299.326 179.409 300.398 180.747H314.601Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M311.045 178.171H303.723C303.295 178.171 302.87 178.087 302.475 177.923C302.079 177.759 301.719 177.518 301.416 177.216C301.113 176.913 300.873 176.553 300.709 176.157C300.545 175.762 300.461 175.337 300.461 174.909C300.46 174.48 300.544 174.056 300.707 173.66C300.871 173.263 301.111 172.903 301.414 172.6C301.717 172.297 302.077 172.057 302.474 171.893C302.87 171.73 303.294 171.646 303.723 171.647H311.045C311.474 171.646 311.898 171.73 312.294 171.893C312.691 172.057 313.05 172.297 313.354 172.6C313.657 172.903 313.897 173.263 314.061 173.66C314.224 174.056 314.308 174.48 314.307 174.909C314.307 175.774 313.963 176.604 313.352 177.216C312.74 177.827 311.91 178.171 311.045 178.171Z",
    fill: "#28CC9E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M301.959 174.643C302.109 174.223 302.382 173.858 302.743 173.596C303.105 173.334 303.536 173.188 303.982 173.176C304.428 173.164 304.867 173.286 305.242 173.528C305.617 173.77 305.909 174.12 306.082 174.531",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M308.805 174.643C308.955 174.223 309.228 173.858 309.589 173.596C309.95 173.334 310.382 173.188 310.828 173.176C311.274 173.164 311.713 173.286 312.088 173.528C312.462 173.77 312.755 174.12 312.928 174.531",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M306.299 176.155C306.331 176.463 306.477 176.747 306.707 176.954C306.937 177.161 307.235 177.276 307.545 177.276C307.854 177.276 308.153 177.161 308.383 176.954C308.613 176.747 308.758 176.463 308.791 176.155H306.299Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M319.264 176.673C319.138 176.673 319.015 176.648 318.899 176.6C318.784 176.553 318.679 176.483 318.59 176.394C318.502 176.306 318.432 176.201 318.384 176.085C318.336 175.97 318.312 175.846 318.312 175.721V173.558C318.312 173.433 318.336 173.309 318.384 173.194C318.432 173.078 318.502 172.973 318.59 172.885C318.679 172.796 318.784 172.726 318.899 172.678C319.015 172.631 319.138 172.606 319.264 172.606C319.389 172.606 319.512 172.631 319.628 172.678C319.743 172.726 319.848 172.796 319.937 172.885C320.025 172.973 320.095 173.078 320.143 173.194C320.191 173.309 320.216 173.433 320.216 173.558V175.7C320.218 175.827 320.196 175.953 320.149 176.071C320.103 176.189 320.033 176.296 319.944 176.387C319.856 176.477 319.75 176.549 319.633 176.599C319.516 176.648 319.39 176.673 319.264 176.673Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M295.477 176.673C295.352 176.673 295.229 176.648 295.113 176.6C294.998 176.553 294.893 176.483 294.804 176.394C294.716 176.306 294.646 176.201 294.598 176.085C294.55 175.97 294.525 175.846 294.525 175.721V173.558C294.525 173.433 294.55 173.309 294.598 173.194C294.646 173.078 294.716 172.973 294.804 172.885C294.893 172.796 294.998 172.726 295.113 172.678C295.229 172.631 295.352 172.606 295.477 172.606C295.602 172.606 295.726 172.631 295.842 172.678C295.957 172.726 296.062 172.796 296.151 172.885C296.239 172.973 296.309 173.078 296.357 173.194C296.405 173.309 296.429 173.433 296.429 173.558V175.7C296.432 175.827 296.41 175.953 296.363 176.071C296.316 176.189 296.247 176.296 296.158 176.387C296.069 176.477 295.964 176.549 295.847 176.599C295.73 176.648 295.604 176.673 295.477 176.673Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M297.234 173.691C296.97 173.689 296.717 173.583 296.531 173.395C296.345 173.208 296.24 172.954 296.24 172.69V171.122C296.237 169.423 296.745 167.762 297.696 166.355C297.765 166.235 297.857 166.13 297.968 166.048C298.078 165.965 298.205 165.906 298.339 165.875C298.474 165.844 298.613 165.841 298.749 165.866C298.885 165.891 299.014 165.944 299.128 166.022C299.242 166.099 299.339 166.199 299.413 166.316C299.486 166.433 299.535 166.564 299.556 166.7C299.577 166.837 299.569 166.976 299.533 167.109C299.497 167.243 299.434 167.367 299.348 167.475C298.62 168.552 298.233 169.822 298.235 171.122V172.69C298.235 172.955 298.13 173.21 297.942 173.398C297.754 173.585 297.5 173.691 297.234 173.691Z",
    fill: "#263238"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M316.568 167.419C316.486 167.419 316.405 167.399 316.333 167.36C316.261 167.321 316.199 167.264 316.155 167.195C315.513 166.238 314.645 165.454 313.628 164.914C312.611 164.373 311.476 164.091 310.324 164.094H304.766C303.614 164.091 302.479 164.373 301.462 164.914C300.444 165.454 299.576 166.238 298.935 167.195C298.86 167.305 298.744 167.381 298.612 167.406C298.481 167.431 298.345 167.403 298.235 167.328C298.179 167.291 298.132 167.244 298.095 167.189C298.058 167.133 298.033 167.071 298.02 167.006C298.008 166.941 298.009 166.874 298.023 166.809C298.037 166.744 298.064 166.682 298.102 166.628C298.836 165.537 299.827 164.643 300.988 164.025C302.149 163.407 303.444 163.085 304.759 163.086H310.317C311.634 163.085 312.93 163.408 314.092 164.027C315.255 164.646 316.247 165.542 316.981 166.635C317.019 166.69 317.045 166.752 317.058 166.817C317.072 166.882 317.072 166.949 317.059 167.015C317.046 167.08 317.02 167.142 316.982 167.197C316.945 167.252 316.897 167.299 316.841 167.335C316.76 167.389 316.665 167.418 316.568 167.419Z",
    fill: "#263238"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M317.856 173.691C317.59 173.691 317.336 173.586 317.148 173.398C316.96 173.21 316.855 172.956 316.855 172.69V171.122C316.858 169.822 316.47 168.552 315.742 167.475C315.658 167.367 315.598 167.242 315.565 167.109C315.531 166.977 315.525 166.838 315.547 166.703C315.569 166.568 315.619 166.439 315.693 166.324C315.767 166.208 315.864 166.11 315.977 166.033C316.091 165.957 316.219 165.905 316.354 165.88C316.489 165.855 316.627 165.858 316.76 165.889C316.894 165.92 317.02 165.978 317.13 166.059C317.24 166.141 317.332 166.244 317.401 166.362C318.35 167.768 318.855 169.426 318.85 171.122V172.69C318.85 172.954 318.745 173.208 318.559 173.395C318.373 173.583 318.12 173.689 317.856 173.691Z",
    fill: "#263238"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M297.36 178.087C296.836 178.087 296.334 177.879 295.964 177.509C295.594 177.139 295.386 176.636 295.386 176.113V172.977C295.386 172.453 295.594 171.951 295.964 171.581C296.334 171.211 296.836 171.003 297.36 171.003C297.883 171.003 298.385 171.211 298.756 171.581C299.126 171.951 299.334 172.453 299.334 172.977V176.113C299.334 176.636 299.126 177.139 298.756 177.509C298.385 177.879 297.883 178.087 297.36 178.087Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M297.563 171.003H297.157V178.087H297.563V171.003Z",
    fill: "#28CC9E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M319.467 172.977C319.467 171.887 318.583 171.003 317.493 171.003C316.402 171.003 315.519 171.887 315.519 172.977V176.113C315.519 177.203 316.402 178.087 317.493 178.087C318.583 178.087 319.467 177.203 319.467 176.113V172.977Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M317.695 171.003H317.289V178.087H317.695V171.003Z",
    fill: "#28CC9E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M307.531 170.359C308.227 170.356 308.911 170.181 309.521 169.848C310.132 169.516 310.651 169.037 311.031 168.455L311.892 167.118C310.528 166.363 308.991 165.972 307.431 165.984C305.871 165.997 304.341 166.411 302.988 167.188L304.276 168.798C304.669 169.284 305.164 169.676 305.728 169.946C306.291 170.216 306.907 170.357 307.531 170.359Z",
    fill: "#28CC9E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M307.601 178.976C307.682 178.976 307.748 178.91 307.748 178.829C307.748 178.748 307.682 178.682 307.601 178.682C307.52 178.682 307.454 178.748 307.454 178.829C307.454 178.91 307.52 178.976 307.601 178.976Z",
    fill: "#263238"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M307.748 179.34C307.746 179.302 307.73 179.267 307.703 179.241C307.675 179.215 307.639 179.2 307.601 179.2C307.582 179.199 307.563 179.202 307.545 179.209C307.528 179.215 307.511 179.225 307.498 179.239C307.484 179.252 307.473 179.267 307.465 179.285C307.458 179.302 307.454 179.321 307.454 179.34C307.454 179.379 307.47 179.416 307.497 179.444C307.525 179.472 307.562 179.487 307.601 179.487C307.64 179.487 307.677 179.472 307.705 179.444C307.733 179.416 307.748 179.379 307.748 179.34Z",
    fill: "#263238"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M307.167 179.263C307.204 179.252 307.235 179.226 307.253 179.192C307.271 179.158 307.276 179.118 307.265 179.081C307.25 179.045 307.223 179.014 307.189 178.996C307.154 178.978 307.114 178.974 307.076 178.983C307.039 178.994 307.008 179.02 306.989 179.054C306.971 179.088 306.967 179.128 306.978 179.165C306.992 179.202 307.019 179.232 307.054 179.25C307.088 179.268 307.129 179.273 307.167 179.263Z",
    fill: "#263238"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M308.084 179.263C308.121 179.252 308.152 179.226 308.17 179.192C308.189 179.158 308.193 179.118 308.182 179.081C308.169 179.043 308.142 179.012 308.107 178.994C308.072 178.976 308.031 178.972 307.993 178.983C307.975 178.989 307.958 178.998 307.943 179.01C307.929 179.022 307.917 179.037 307.908 179.054C307.9 179.071 307.895 179.09 307.894 179.109C307.893 179.128 307.895 179.147 307.902 179.165C307.913 179.202 307.939 179.233 307.973 179.251C308.007 179.27 308.047 179.274 308.084 179.263Z",
    fill: "#263238"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M289.016 96.7051H233.317V71.8901V65.3101L239.904 71.8901H289.016V96.7051Z",
    fill: "#D6D6D6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M289.016 132.65H233.317V107.842V101.262L239.904 107.842H289.016V132.65Z",
    fill: "#D6D6D6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M270.508 80.4299H283.619",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M252.161 80.4299H267.141",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M240.926 80.4299H249.536",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M264.516 84.553H283.619",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M240.926 84.553H261.149",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M279.874 88.6689H283.619",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M258.902 88.6689H276.878",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M240.926 88.6689H255.906",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M270.508 115.255H283.619",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M252.161 115.255H267.141",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M240.926 115.255H249.536",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M264.516 119.378H283.619",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M240.926 119.378H261.149",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M279.874 123.494H283.619",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M258.902 123.494H276.878",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M240.926 123.494H255.906",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M233.317 233.737H289.016V173.726V167.146L282.429 173.726H233.317V233.737Z",
    fill: "#28CC9E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M270.508 181.916H283.619",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M252.161 181.916H267.141",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M240.926 181.916H249.536",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M264.516 186.032H283.619",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M240.926 186.032H261.149",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M279.874 190.155H283.619",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M258.902 190.155H276.878",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M240.926 190.155H255.906",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M270.508 193.522H283.619",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M252.161 193.522H267.141",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M240.926 193.522H249.536",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M264.516 197.645H283.619",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M240.926 197.645H261.149",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M279.874 201.761H283.619",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M258.902 201.761H276.878",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M240.926 201.761H255.906",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M270.508 205.135H283.619",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M252.161 205.135H267.141",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M240.926 205.135H249.536",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M264.516 209.251H283.619",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M240.926 209.251H261.149",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M279.874 213.374H283.619",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M258.902 213.374H276.878",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M240.926 213.374H255.906",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M270.508 216.741H283.619",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M252.161 216.741H267.141",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M240.926 216.741H249.536",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M264.516 220.864H283.619",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M240.926 220.864H261.149",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M279.874 224.98H283.619",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M258.902 224.98H276.878",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M240.926 224.98H255.906",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M307.37 267.106C315.62 267.106 322.308 260.418 322.308 252.168C322.308 243.918 315.62 237.23 307.37 237.23C299.12 237.23 292.432 243.918 292.432 252.168C292.432 260.418 299.12 267.106 307.37 267.106Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M312.466 256.571C312.468 257.554 312.177 258.516 311.632 259.334C311.087 260.152 310.311 260.79 309.403 261.168C308.495 261.545 307.496 261.644 306.531 261.453C305.567 261.262 304.68 260.789 303.985 260.095C303.289 259.4 302.815 258.514 302.622 257.55C302.43 256.586 302.528 255.586 302.904 254.678C303.28 253.769 303.917 252.992 304.734 252.446C305.552 251.9 306.513 251.608 307.496 251.608C308.813 251.608 310.076 252.131 311.008 253.061C311.94 253.992 312.465 255.254 312.466 256.571Z",
    fill: "#28CC9E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M314.601 259.882C315.673 258.544 316.345 256.93 316.54 255.226C316.735 253.523 316.445 251.799 315.703 250.253C314.961 248.707 313.797 247.403 312.345 246.489C310.894 245.576 309.214 245.092 307.499 245.092C305.785 245.092 304.105 245.576 302.653 246.489C301.202 247.403 300.038 248.707 299.296 250.253C298.554 251.799 298.263 253.523 298.458 255.226C298.653 256.93 299.326 258.544 300.398 259.882H314.601Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M311.045 257.306H303.723C303.295 257.306 302.87 257.222 302.475 257.058C302.079 256.894 301.719 256.653 301.416 256.351C301.113 256.048 300.873 255.688 300.709 255.292C300.545 254.897 300.461 254.472 300.461 254.044C300.461 253.616 300.545 253.191 300.709 252.796C300.873 252.4 301.113 252.04 301.416 251.737C301.719 251.434 302.079 251.194 302.475 251.03C302.87 250.866 303.295 250.782 303.723 250.782H311.045C311.473 250.782 311.897 250.866 312.293 251.03C312.689 251.194 313.049 251.434 313.352 251.737C313.654 252.04 313.895 252.4 314.059 252.796C314.223 253.191 314.307 253.616 314.307 254.044C314.307 254.909 313.963 255.739 313.352 256.351C312.74 256.962 311.91 257.306 311.045 257.306Z",
    fill: "#28CC9E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M301.959 253.778C302.109 253.358 302.382 252.993 302.743 252.731C303.105 252.469 303.536 252.323 303.982 252.311C304.428 252.299 304.867 252.421 305.242 252.663C305.617 252.905 305.909 253.255 306.082 253.666",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M308.805 253.778C308.955 253.358 309.228 252.993 309.589 252.731C309.95 252.469 310.382 252.323 310.828 252.311C311.274 252.299 311.713 252.421 312.088 252.663C312.462 252.905 312.755 253.255 312.928 253.666",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M306.299 255.29C306.331 255.598 306.477 255.882 306.707 256.089C306.937 256.296 307.235 256.411 307.545 256.411C307.854 256.411 308.153 256.296 308.383 256.089C308.613 255.882 308.758 255.598 308.791 255.29H306.299Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M319.264 255.808C319.011 255.808 318.769 255.708 318.59 255.529C318.412 255.351 318.312 255.109 318.312 254.856V252.7C318.312 252.448 318.412 252.205 318.59 252.027C318.769 251.848 319.011 251.748 319.264 251.748C319.516 251.748 319.758 251.848 319.937 252.027C320.115 252.205 320.216 252.448 320.216 252.7V254.863C320.214 255.114 320.113 255.355 319.934 255.532C319.756 255.709 319.515 255.808 319.264 255.808Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M295.477 255.808C295.225 255.808 294.983 255.708 294.804 255.529C294.626 255.351 294.525 255.109 294.525 254.856V252.7C294.525 252.448 294.626 252.205 294.804 252.027C294.983 251.848 295.225 251.748 295.477 251.748C295.73 251.748 295.972 251.848 296.151 252.027C296.329 252.205 296.429 252.448 296.429 252.7V254.863C296.428 255.114 296.326 255.355 296.148 255.532C295.97 255.709 295.729 255.808 295.477 255.808Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M297.234 252.833C296.97 252.831 296.717 252.725 296.531 252.537C296.345 252.35 296.24 252.096 296.24 251.832V250.257C296.238 248.558 296.745 246.898 297.696 245.49C297.853 245.293 298.079 245.163 298.328 245.125C298.577 245.087 298.831 245.145 299.04 245.286C299.249 245.428 299.396 245.642 299.453 245.888C299.51 246.133 299.473 246.391 299.348 246.61C298.62 247.687 298.233 248.957 298.235 250.257V251.832C298.235 252.097 298.13 252.352 297.942 252.54C297.754 252.728 297.5 252.833 297.234 252.833Z",
    fill: "#263238"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M316.568 246.554C316.487 246.554 316.407 246.534 316.335 246.496C316.263 246.458 316.202 246.404 316.155 246.337C315.514 245.379 314.647 244.594 313.63 244.052C312.612 243.51 311.477 243.227 310.324 243.229H304.766C303.615 243.23 302.481 243.513 301.465 244.054C300.448 244.594 299.58 245.376 298.935 246.33C298.899 246.384 298.852 246.431 298.797 246.467C298.742 246.503 298.681 246.528 298.616 246.54C298.552 246.552 298.486 246.552 298.422 246.539C298.358 246.526 298.297 246.5 298.242 246.463C298.188 246.426 298.142 246.379 298.106 246.324C298.07 246.27 298.045 246.208 298.032 246.144C298.02 246.08 298.02 246.014 298.034 245.949C298.047 245.885 298.073 245.824 298.109 245.77C298.843 244.679 299.834 243.785 300.995 243.167C302.156 242.55 303.451 242.227 304.766 242.228H310.324C311.641 242.228 312.937 242.552 314.099 243.171C315.261 243.79 316.253 244.685 316.988 245.777C317.026 245.832 317.053 245.894 317.066 245.959C317.079 246.024 317.08 246.091 317.067 246.157C317.054 246.222 317.028 246.284 316.99 246.339C316.953 246.394 316.904 246.441 316.848 246.477C316.765 246.53 316.667 246.556 316.568 246.554Z",
    fill: "#263238"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M317.856 252.833C317.591 252.833 317.336 252.728 317.148 252.54C316.961 252.352 316.855 252.098 316.855 251.832V250.257C316.857 248.96 316.469 247.692 315.742 246.617C315.666 246.508 315.612 246.385 315.584 246.255C315.555 246.125 315.553 245.991 315.577 245.86C315.601 245.73 315.651 245.605 315.724 245.494C315.797 245.382 315.891 245.287 316.001 245.212C316.112 245.138 316.236 245.086 316.366 245.06C316.496 245.034 316.631 245.035 316.761 245.061C316.891 245.088 317.015 245.14 317.125 245.215C317.235 245.29 317.329 245.386 317.401 245.497C318.35 246.903 318.855 248.561 318.85 250.257V251.832C318.85 252.096 318.746 252.35 318.56 252.537C318.373 252.725 318.12 252.831 317.856 252.833Z",
    fill: "#263238"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M297.36 257.229C296.836 257.229 296.334 257.021 295.964 256.651C295.594 256.281 295.386 255.778 295.386 255.255V252.112C295.386 251.588 295.594 251.086 295.964 250.716C296.334 250.346 296.836 250.138 297.36 250.138C297.883 250.138 298.385 250.346 298.756 250.716C299.126 251.086 299.334 251.588 299.334 252.112V255.255C299.332 255.778 299.123 256.279 298.754 256.649C298.384 257.019 297.883 257.227 297.36 257.229Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M297.563 250.138H297.157V257.222H297.563V250.138Z",
    fill: "#28CC9E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M319.467 252.112C319.467 251.022 318.583 250.138 317.493 250.138C316.402 250.138 315.519 251.022 315.519 252.112V255.248C315.519 256.338 316.402 257.222 317.493 257.222C318.583 257.222 319.467 256.338 319.467 255.248V252.112Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M317.695 250.138H317.289V257.222H317.695V250.138Z",
    fill: "#28CC9E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M307.531 249.494C308.227 249.491 308.911 249.316 309.521 248.984C310.132 248.651 310.651 248.172 311.031 247.59L311.892 246.26C310.527 245.507 308.991 245.117 307.432 245.128C305.873 245.139 304.343 245.551 302.988 246.323L304.276 247.933C304.669 248.419 305.164 248.811 305.728 249.081C306.291 249.351 306.907 249.492 307.531 249.494Z",
    fill: "#28CC9E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M307.601 258.111C307.682 258.111 307.748 258.045 307.748 257.964C307.748 257.883 307.682 257.817 307.601 257.817C307.52 257.817 307.454 257.883 307.454 257.964C307.454 258.045 307.52 258.111 307.601 258.111Z",
    fill: "#263238"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M307.601 258.629C307.682 258.629 307.748 258.563 307.748 258.482C307.748 258.401 307.682 258.335 307.601 258.335C307.52 258.335 307.454 258.401 307.454 258.482C307.454 258.563 307.52 258.629 307.601 258.629Z",
    fill: "#263238"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M307.167 258.398C307.204 258.387 307.235 258.361 307.253 258.327C307.272 258.293 307.276 258.253 307.265 258.216C307.251 258.18 307.224 258.149 307.189 258.131C307.154 258.113 307.114 258.109 307.076 258.118C307.04 258.131 307.01 258.157 306.992 258.19C306.974 258.224 306.969 258.263 306.978 258.3C306.984 258.319 306.993 258.337 307.006 258.352C307.018 258.368 307.034 258.38 307.052 258.39C307.069 258.399 307.089 258.404 307.108 258.406C307.128 258.407 307.148 258.405 307.167 258.398Z",
    fill: "#263238"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M308.084 258.398C308.121 258.387 308.152 258.361 308.17 258.327C308.189 258.293 308.193 258.253 308.182 258.216C308.169 258.179 308.142 258.147 308.107 258.129C308.072 258.111 308.031 258.107 307.993 258.118C307.975 258.124 307.958 258.133 307.943 258.145C307.929 258.157 307.917 258.172 307.908 258.189C307.9 258.206 307.895 258.225 307.894 258.244C307.893 258.263 307.895 258.282 307.902 258.3C307.907 258.319 307.915 258.337 307.927 258.352C307.939 258.367 307.954 258.38 307.971 258.389C307.989 258.398 308.007 258.404 308.027 258.405C308.046 258.407 308.066 258.404 308.084 258.398Z",
    fill: "#263238"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M233.317 288.281H289.016V252.861V246.281L282.429 252.861H233.317V288.281Z",
    fill: "#28CC9E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M270.508 261.051H283.619",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M252.161 261.051H267.141",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M240.926 261.051H249.536",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M264.516 265.174H283.619",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M240.926 265.174H261.149",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M279.874 269.29H283.619",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M258.902 269.29H276.878",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M240.926 269.29H255.906",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M270.508 272.664H283.619",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M252.161 272.664H267.141",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M240.926 272.664H249.536",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M264.516 276.78H283.619",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M240.926 276.78H261.149",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M279.874 280.896H283.619",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M258.902 280.896H276.878",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M240.926 280.896H255.906",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M317.1 38.906H288.204C287.901 40.5063 287.049 41.9509 285.796 42.991C284.542 44.0311 282.965 44.6015 281.337 44.604H239.967C238.338 44.6015 236.761 44.0311 235.508 42.991C234.254 41.9509 233.403 40.5063 233.1 38.906H204.239C201.825 38.906 199.511 39.8648 197.804 41.5713C196.097 43.2779 195.139 45.5925 195.139 48.006V292.306C195.139 294.719 196.097 297.034 197.804 298.741C199.511 300.447 201.825 301.406 204.239 301.406H317.1C319.513 301.406 321.828 300.447 323.534 298.741C325.241 297.034 326.2 294.719 326.2 292.306V48.006C326.2 45.5925 325.241 43.2779 323.534 41.5713C321.828 39.8648 319.513 38.906 317.1 38.906Z",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M326.2 55.391V48.013C326.2 45.5995 325.241 43.2849 323.534 41.5783C321.828 39.8718 319.513 38.913 317.1 38.913H288.204C287.901 40.5133 287.049 41.9579 285.796 42.998C284.542 44.0381 282.965 44.6085 281.337 44.611H239.967C238.337 44.6082 236.759 44.0368 235.506 42.9953C234.252 41.9539 233.401 40.5076 233.1 38.906H204.239C201.825 38.906 199.511 39.8648 197.804 41.5713C196.097 43.2779 195.139 45.5925 195.139 48.006V55.391H326.2Z",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M207.144 45.5C207.144 47.292 205.128 47.936 205.121 49.301V49.392H207.074V50.001H204.47V49.49C204.47 47.6 206.5 47.194 206.5 45.5C206.5 44.884 206.297 44.562 205.8 44.562C205.303 44.562 205.1 44.912 205.1 45.437V45.962H204.484V45.5C204.484 44.59 204.897 43.988 205.814 43.988C206.731 43.988 207.144 44.59 207.144 45.5Z",
    fill: "#263238"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M210.392 45.5V45.654C210.422 45.9053 210.37 46.1595 210.244 46.379C210.118 46.5984 209.924 46.7713 209.692 46.872C209.927 46.9733 210.122 47.1484 210.248 47.3707C210.375 47.593 210.425 47.8504 210.392 48.104V48.559C210.392 49.469 209.965 50.064 209.055 50.064C208.145 50.064 207.718 49.469 207.718 48.559V48.153H208.341V48.601C208.341 49.14 208.558 49.462 209.041 49.462C209.524 49.462 209.741 49.147 209.741 48.545V48.09C209.741 47.502 209.489 47.222 208.992 47.201H208.6V46.613H208.992C209.095 46.6144 209.197 46.5933 209.29 46.5509C209.384 46.5085 209.467 46.446 209.534 46.3678C209.601 46.2896 209.65 46.1977 209.677 46.0985C209.704 45.9993 209.709 45.8953 209.692 45.794V45.5C209.692 44.891 209.475 44.576 208.992 44.576C208.509 44.576 208.292 44.905 208.292 45.444V45.752H207.669V45.5C207.669 44.59 208.096 44.002 209.006 44.002C209.916 44.002 210.392 44.583 210.392 45.5Z",
    fill: "#263238"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M211.673 45.9409V46.7669H211.036V45.9409H211.673ZM211.673 49.1749V50.0009H211.036V49.1749H211.673Z",
    fill: "#263238"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M213.017 46.4731C213.104 46.3175 213.233 46.1893 213.389 46.1027C213.544 46.0162 213.721 45.9748 213.899 45.9831C214.662 45.9831 215.005 46.5431 215.005 47.3831V48.5451C215.005 49.4551 214.571 50.0501 213.661 50.0501C212.751 50.0501 212.331 49.4551 212.331 48.5451V48.1461H212.947V48.5871C212.947 49.1261 213.171 49.4481 213.647 49.4481C214.123 49.4481 214.347 49.1261 214.347 48.5871V47.4461C214.347 46.9071 214.13 46.5851 213.647 46.5851C213.558 46.5763 213.469 46.5862 213.384 46.6142C213.299 46.6423 213.221 46.6878 213.155 46.7479C213.089 46.8079 213.037 46.8812 213.001 46.9629C212.965 47.0446 212.947 47.1329 212.947 47.2221V47.3551H212.324L212.485 44.0581H214.83V44.6531H213.08L213.017 46.4731Z",
    fill: "#263238"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M218.302 45.5V45.605H217.7V45.451C217.7 44.919 217.476 44.604 217 44.604C216.524 44.604 216.3 44.926 216.3 45.563V46.9C216.368 46.7037 216.499 46.5352 216.672 46.4201C216.845 46.3051 217.051 46.2499 217.259 46.263C218.022 46.263 218.365 46.809 218.365 47.663V48.559C218.365 49.469 217.917 50.064 217.007 50.064C216.097 50.064 215.6 49.462 215.6 48.552V45.5C215.6 44.555 216.02 43.967 216.965 43.967C217.91 43.967 218.302 44.576 218.302 45.5ZM216.258 47.719V48.608C216.258 49.147 216.482 49.469 216.958 49.469C217.434 49.469 217.658 49.147 217.658 48.608V47.705C217.658 47.173 217.427 46.851 216.958 46.851C216.489 46.851 216.258 47.173 216.258 47.705V47.719Z",
    fill: "#263238"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M291.669 45.7451H289.989V49.9381H291.669V45.7451Z",
    fill: "#263238"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M293.909 44.905H292.229V49.938H293.909V44.905Z",
    fill: "#263238"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M296.142 44.3101H294.462V49.9381H296.142V44.3101Z",
    fill: "#263238"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M298.382 43.2671H296.702V49.9381H298.382V43.2671Z",
    fill: "#263238"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M319.137 49.8191H309.071V43.6731H319.137V49.8191ZM309.631 49.2661H318.577V44.2331H309.631V49.2661Z",
    fill: "#263238"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M315.784 44.842H310.471V48.657H315.784V44.842Z",
    fill: "#263238"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M320.054 46.0249H318.787V47.4739H320.054V46.0249Z",
    fill: "#263238"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M305.382 48.4821C305.316 48.4833 305.25 48.4664 305.193 48.4331C303.142 47.2151 301.791 48.3421 301.735 48.3911C301.699 48.4281 301.655 48.4572 301.607 48.4766C301.558 48.4959 301.507 48.5051 301.455 48.5036C301.403 48.5021 301.352 48.4899 301.305 48.4677C301.258 48.4456 301.216 48.414 301.182 48.3749C301.147 48.3359 301.122 48.2901 301.106 48.2406C301.09 48.1911 301.085 48.1389 301.09 48.0872C301.095 48.0355 301.111 47.9855 301.137 47.9402C301.162 47.8949 301.197 47.8554 301.238 47.8241C301.308 47.7611 303.044 46.2771 305.578 47.7821C305.662 47.8355 305.722 47.9192 305.745 48.0158C305.769 48.1123 305.754 48.2142 305.704 48.3001C305.671 48.356 305.624 48.4022 305.567 48.4341C305.511 48.466 305.447 48.4826 305.382 48.4821Z",
    fill: "#263238"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M306.139 47.2221C306.072 47.2208 306.006 47.2014 305.95 47.1661C302.989 45.4091 300.994 47.1101 300.973 47.1241C300.936 47.1562 300.893 47.1809 300.847 47.1965C300.8 47.2122 300.752 47.2186 300.703 47.2153C300.654 47.2121 300.606 47.1992 300.563 47.1776C300.519 47.1559 300.48 47.1258 300.448 47.0891C300.415 47.0523 300.391 47.0096 300.375 46.9633C300.359 46.917 300.353 46.8681 300.356 46.8193C300.36 46.7706 300.372 46.7229 300.394 46.6791C300.416 46.6353 300.446 46.5962 300.483 46.5641C300.483 46.5641 302.905 44.4641 306.335 46.5221C306.42 46.5742 306.481 46.658 306.504 46.7551C306.528 46.8521 306.512 46.9546 306.461 47.0401C306.427 47.0954 306.38 47.1413 306.323 47.1731C306.267 47.205 306.203 47.2219 306.139 47.2221Z",
    fill: "#263238"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M306.831 45.7589C306.762 45.7575 306.695 45.7382 306.635 45.7029C302.883 43.4769 300.391 45.5769 300.286 45.6679C300.21 45.7255 300.115 45.752 300.02 45.7423C299.925 45.7325 299.837 45.6872 299.774 45.6154C299.711 45.5436 299.678 45.4507 299.681 45.3552C299.684 45.2598 299.722 45.1689 299.789 45.1009C299.824 45.1009 302.785 42.5389 307.02 45.0589C307.063 45.0842 307.101 45.1176 307.13 45.1573C307.16 45.197 307.182 45.2422 307.194 45.2904C307.207 45.3385 307.209 45.3885 307.202 45.4377C307.195 45.4869 307.179 45.5342 307.153 45.5769C307.119 45.6318 307.072 45.6773 307.016 45.7091C306.959 45.7409 306.896 45.7581 306.831 45.7589Z",
    fill: "#263238"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M304.248 49.1121C304.25 49.2996 304.195 49.4833 304.092 49.6397C303.989 49.7962 303.841 49.9184 303.668 49.9908C303.495 50.0632 303.305 50.0825 303.121 50.0463C302.937 50.01 302.768 49.9199 302.635 49.7873C302.503 49.6547 302.412 49.4857 302.376 49.3017C302.34 49.1178 302.359 48.9272 302.432 48.7542C302.504 48.5813 302.626 48.4337 302.783 48.3304C302.939 48.2271 303.123 48.1727 303.31 48.1741C303.559 48.1741 303.798 48.2729 303.974 48.4488C304.15 48.6247 304.248 48.8633 304.248 49.1121Z",
    fill: "#263238"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M315.7 312.557H330.4",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 312.557H310.8",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3555 312.557H29.4005",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M120.175 218.288H109.479V311.248H120.175V218.288Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3643 251.951V258.489H77.9943V251.951H35.3643Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M39.746 229.383H33.208V255.542H39.746V229.383Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4686 255.654C42.4686 256.441 42.3136 257.219 42.0124 257.946C41.7112 258.673 41.2697 259.333 40.7132 259.889C40.1567 260.444 39.4961 260.885 38.7691 261.185C38.0422 261.486 37.2632 261.64 36.4766 261.639C36.2806 261.639 36.0846 261.639 35.8956 261.639C34.8054 261.531 33.7655 261.127 32.8892 260.469C32.0128 259.812 31.3335 258.926 30.9251 257.91C30.5167 256.893 30.3948 255.784 30.5727 254.703C30.7506 253.622 31.2215 252.61 31.9342 251.778C32.6469 250.946 33.574 250.325 34.6149 249.983C35.6557 249.641 36.7704 249.591 37.8377 249.839C38.905 250.086 39.8841 250.621 40.6685 251.386C41.4529 252.151 42.0125 253.116 42.2866 254.177C42.4061 254.66 42.4672 255.156 42.4686 255.654Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9094 233.415C42.9057 235.002 42.273 236.524 41.1499 237.645C40.0268 238.767 38.5048 239.398 36.9175 239.4C36.7215 239.4 36.5255 239.4 36.3295 239.4C35.2386 239.295 34.1974 238.894 33.319 238.239C32.4406 237.584 31.7586 236.7 31.3473 235.684C30.936 234.669 30.8111 233.56 30.9862 232.478C31.1612 231.396 31.6296 230.383 32.3403 229.549C33.051 228.715 33.9768 228.092 35.017 227.747C36.0572 227.403 37.172 227.35 38.2401 227.595C39.3082 227.84 40.2887 228.373 41.0749 229.136C41.8612 229.899 42.4231 230.864 42.6995 231.924C42.8339 232.41 42.9045 232.911 42.9094 233.415Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6388 217.175L44.9238 221.867L46.7292 225.22L55.4441 220.528L53.6388 217.175Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8885 220.892L52.5975 223.202L49.8535 218.113L54.1515 215.796C54.4888 215.611 54.8596 215.496 55.2421 215.456C55.6247 215.417 56.0113 215.454 56.3791 215.566C56.747 215.679 57.0887 215.863 57.3842 216.109C57.6796 216.356 57.9228 216.658 58.0995 217C58.4508 217.677 58.5206 218.466 58.2939 219.195C58.0672 219.924 57.5621 220.533 56.8885 220.892Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0797 199.311L37.7717 217.063L33.9707 217L34.2717 199.248L38.0797 199.311Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M39.109 198.24L39.032 203.14L33.25 203L33.327 198.1C33.3334 197.72 33.4145 197.346 33.5657 196.997C33.7169 196.649 33.9353 196.334 34.2083 196.07C34.4813 195.806 34.8036 195.599 35.1569 195.459C35.5101 195.32 35.8873 195.252 36.267 195.258C36.6506 195.263 37.0292 195.345 37.3808 195.499C37.7323 195.652 38.0497 195.874 38.3144 196.152C38.579 196.43 38.7856 196.757 38.9221 197.116C39.0585 197.474 39.1221 197.857 39.109 198.24Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3038 205.751L43.9528 221.417L40.5928 219.632L48.9368 203.966L52.3038 205.751Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7035 205.268L51.4145 209.573L46.3115 206.864L48.5935 202.552C48.9546 201.877 49.5679 201.372 50.2997 201.148C51.0315 200.924 51.8223 200.998 52.4995 201.355C53.1775 201.715 53.685 202.329 53.9107 203.063C54.1364 203.796 54.0619 204.589 53.7035 205.268Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5838 205.681L32.8578 221.389L29.4908 223.167L21.2168 207.459L24.5838 205.681Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3472 217.07C32.2245 216.344 31.889 215.67 31.3832 215.134C30.8774 214.598 30.224 214.224 29.5057 214.06C28.7875 213.896 28.0366 213.948 27.3481 214.211C26.6597 214.473 26.0646 214.934 25.6381 215.535C25.2117 216.136 24.9732 216.85 24.9526 217.587C24.9321 218.323 25.1305 219.049 25.5228 219.673C25.9151 220.297 26.4835 220.79 27.1563 221.09C27.8291 221.391 28.5759 221.485 29.3022 221.361C30.2746 221.195 31.1413 220.65 31.7122 219.845C32.2831 219.041 32.5114 218.043 32.3472 217.07Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9867 217.56C38.0434 217.56 39.7107 215.893 39.7107 213.836C39.7107 211.779 38.0434 210.112 35.9867 210.112C33.93 210.112 32.2627 211.779 32.2627 213.836C32.2627 215.893 33.93 217.56 35.9867 217.56Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M48.139 215.985C48.2511 215.257 48.1447 214.512 47.8332 213.844C47.5217 213.176 47.0191 212.616 46.3891 212.234C45.7591 211.852 45.03 211.666 44.2939 211.698C43.5579 211.731 42.8481 211.981 42.2542 212.417C41.6604 212.853 41.2092 213.455 40.9578 214.148C40.7065 214.841 40.6662 215.592 40.842 216.308C41.0179 217.023 41.4021 217.67 41.9459 218.167C42.4897 218.664 43.1687 218.989 43.897 219.1C44.3802 219.175 44.8733 219.153 45.3481 219.037C45.823 218.921 46.2702 218.712 46.6643 218.423C47.0583 218.133 47.3914 217.769 47.6445 217.351C47.8975 216.932 48.0656 216.468 48.139 215.985Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9689 204.246L27.2509 208.558L22.1409 211.267L19.8589 206.948C19.6806 206.613 19.5704 206.246 19.5344 205.868C19.4985 205.489 19.5376 205.108 19.6494 204.745C19.7613 204.382 19.9438 204.045 20.1863 203.753C20.4289 203.46 20.7268 203.219 21.0629 203.042C21.7409 202.686 22.5324 202.613 23.2643 202.838C23.9962 203.064 24.609 203.57 24.9689 204.246Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4248 224.259C47.4248 227.044 46.3186 229.715 44.3495 231.684C42.3803 233.653 39.7096 234.759 36.9248 234.759C36.5748 234.759 36.2248 234.759 35.8958 234.717C33.9858 234.528 32.1642 233.818 30.6291 232.666C29.0939 231.514 27.9039 229.963 27.1884 228.182C26.4729 226.401 26.2593 224.458 26.5708 222.564C26.8823 220.67 27.707 218.898 28.9552 217.44C30.2035 215.982 31.8275 214.894 33.6508 214.294C35.474 213.694 37.4268 213.606 39.2969 214.038C41.1669 214.471 42.8827 215.407 44.2577 216.746C45.6327 218.086 46.6143 219.776 47.0958 221.634C47.3129 222.492 47.4234 223.374 47.4248 224.259Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4248 224.259C47.4248 227.044 46.3185 229.714 44.3494 231.684C42.3803 233.653 39.7096 234.759 36.9248 234.759C36.5748 234.759 36.2248 234.759 35.8958 234.717C35.4935 233.163 35.4527 231.538 35.7765 229.967C36.1003 228.395 36.78 226.918 37.7635 225.65C38.7471 224.382 40.0082 223.356 41.45 222.651C42.8918 221.947 44.476 221.582 46.0808 221.585C46.4238 221.585 46.7808 221.585 47.1098 221.634C47.3222 222.493 47.428 223.374 47.4248 224.259Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M100.296 255.843C102.079 248.224 97.348 240.603 89.729 238.82C82.11 237.037 74.4884 241.768 72.7056 249.387C70.9228 257.006 75.6539 264.628 83.2729 266.411C90.8919 268.193 98.5135 263.462 100.296 255.843Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1334 258.951C92.6337 257.491 94.2878 253.47 92.8279 249.97C91.368 246.469 87.3469 244.815 83.8466 246.275C80.3463 247.735 78.6923 251.756 80.1522 255.257C81.6121 258.757 85.6331 260.411 89.1334 258.951Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0628 312.557H146.923L147.826 308.301C148.188 306.601 147.863 304.827 146.921 303.366C145.979 301.905 144.498 300.875 142.8 300.503C133.889 298.501 114.597 297.78 114.597 297.78C109.949 297.927 97.0128 298.48 88.1018 300.51C86.4158 300.895 84.9491 301.928 84.019 303.386C83.0889 304.844 82.7702 306.61 83.1318 308.301L84.0628 312.557Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M130.62 298.816C122.57 298.074 114.618 297.78 114.618 297.78C111.692 297.871 105.476 298.13 99.0498 298.816C100.926 305.221 107.282 309.939 114.835 309.939C122.388 309.939 128.744 305.2 130.62 298.816Z",
    fill: "#28CC9E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M180.49 282.542L184.4 277.302L150.234 251.807L146.324 257.047L180.49 282.542Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M163.488 298.011L168.728 301.921L184.372 280.955L179.132 277.045L163.488 298.011Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M177.009 275.324C177.48 274.692 178.072 274.159 178.749 273.756C179.426 273.353 180.176 273.087 180.957 272.974C181.737 272.861 182.531 272.903 183.295 273.097C184.059 273.291 184.778 273.634 185.409 274.106L185.864 274.477C186.674 275.215 187.265 276.162 187.574 277.213C187.884 278.264 187.899 279.38 187.618 280.439C187.337 281.498 186.771 282.46 185.982 283.22C185.193 283.98 184.21 284.509 183.141 284.75C182.072 284.99 180.958 284.933 179.919 284.584C178.88 284.236 177.957 283.609 177.25 282.772C176.542 281.935 176.078 280.92 175.907 279.838C175.736 278.756 175.866 277.647 176.281 276.633C176.469 276.168 176.713 275.729 177.009 275.324Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M163.338 292.075C164.225 290.757 165.6 289.846 167.159 289.541C168.719 289.236 170.336 289.564 171.654 290.451C171.815 290.556 171.969 290.675 172.123 290.794C172.968 291.492 173.605 292.408 173.966 293.442C174.327 294.477 174.397 295.591 174.169 296.663C173.941 297.735 173.423 298.723 172.672 299.521C171.921 300.32 170.966 300.896 169.91 301.189C168.854 301.482 167.738 301.48 166.683 301.183C165.628 300.885 164.675 300.305 163.928 299.503C163.18 298.702 162.666 297.711 162.443 296.639C162.219 295.566 162.294 294.452 162.659 293.419C162.828 292.945 163.056 292.493 163.338 292.075Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M145.345 299.574L155.195 300.542L155.568 296.752L145.717 295.785L145.345 299.574Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M144.746 294.7L149.604 295.176L149.037 300.93L144.179 300.454C143.416 300.38 142.714 300.005 142.227 299.413C141.74 298.821 141.508 298.06 141.582 297.297C141.658 296.534 142.034 295.831 142.627 295.344C143.22 294.858 143.982 294.626 144.746 294.7Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M154.476 297.15C155.245 296.004 156.233 295.02 157.383 294.256C158.533 293.492 159.822 292.962 161.177 292.696C162.533 292.431 163.927 292.436 165.28 292.71C166.633 292.984 167.919 293.522 169.064 294.294C169.351 294.49 169.624 294.693 169.89 294.91C171.37 296.133 172.486 297.738 173.117 299.552C173.749 301.365 173.871 303.316 173.47 305.194C173.07 307.072 172.162 308.803 170.846 310.201C169.53 311.599 167.856 312.61 166.006 313.122C164.156 313.635 162.201 313.631 160.353 313.11C158.505 312.59 156.835 311.572 155.525 310.169C154.215 308.765 153.315 307.029 152.923 305.15C152.53 303.27 152.661 301.32 153.3 299.509C153.59 298.676 153.985 297.883 154.476 297.15Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M143.164 308.056L156.184 298.319L158.277 301.112L145.257 310.842L143.164 308.056Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M141.813 307.909L145.39 305.2L148.568 309.4L144.991 312.081C144.43 312.502 143.724 312.682 143.03 312.582C142.335 312.482 141.709 312.111 141.288 311.549C140.885 310.993 140.714 310.302 140.812 309.623C140.91 308.943 141.269 308.328 141.813 307.909Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M159.978 301.322C160.144 300.603 160.092 299.851 159.829 299.162C159.567 298.472 159.106 297.877 158.504 297.45C157.902 297.023 157.187 296.784 156.45 296.764C155.713 296.744 154.986 296.944 154.362 297.337C153.738 297.731 153.245 298.301 152.946 298.975C152.646 299.649 152.554 300.397 152.68 301.124C152.806 301.851 153.145 302.524 153.655 303.058C154.164 303.591 154.82 303.962 155.54 304.122C156.5 304.336 157.505 304.161 158.336 303.636C159.167 303.112 159.758 302.28 159.978 301.322Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M166.88 317.842L168.812 304.486L171.675 304.892L169.75 318.248L166.88 317.842Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M166.005 318.549L166.53 314.874L170.877 315.497L170.352 319.165C170.312 319.451 170.216 319.726 170.069 319.975C169.922 320.223 169.728 320.441 169.497 320.614C169.266 320.788 169.004 320.914 168.724 320.986C168.444 321.058 168.153 321.075 167.867 321.034C167.291 320.951 166.771 320.642 166.422 320.177C166.073 319.711 165.923 319.125 166.005 318.549Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M172.794 304.017C172.465 303.504 171.99 303.099 171.431 302.855C170.872 302.611 170.253 302.538 169.652 302.646C169.052 302.753 168.496 303.036 168.057 303.459C167.617 303.882 167.312 304.426 167.181 305.022C167.05 305.618 167.099 306.239 167.321 306.808C167.543 307.376 167.929 307.866 168.429 308.215C168.929 308.565 169.522 308.758 170.132 308.771C170.742 308.784 171.342 308.615 171.856 308.287C172.546 307.845 173.033 307.147 173.209 306.346C173.385 305.546 173.236 304.708 172.794 304.017Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M153.993 316.064L162.673 302.316L165.62 304.164L156.947 317.919L153.993 316.064Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M152.684 316.4L155.057 312.62L159.544 315.42L157.164 319.207C156.789 319.8 156.196 320.22 155.512 320.376C154.829 320.532 154.112 320.411 153.517 320.04C152.925 319.667 152.505 319.074 152.349 318.392C152.193 317.71 152.313 316.994 152.684 316.4Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M167.3 303.758C167.196 303.029 166.878 302.348 166.387 301.8C165.895 301.252 165.251 300.862 164.538 300.68C163.824 300.498 163.073 300.533 162.379 300.779C161.685 301.025 161.079 301.471 160.64 302.062C160.2 302.652 159.945 303.36 159.908 304.095C159.871 304.831 160.053 305.56 160.432 306.192C160.81 306.824 161.367 307.329 162.033 307.643C162.699 307.958 163.443 308.067 164.171 307.958C165.142 307.814 166.017 307.292 166.603 306.505C167.19 305.717 167.44 304.73 167.3 303.758Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M151.219 264.774C157.799 260.539 159.699 251.772 155.464 245.192C151.228 238.613 142.461 236.713 135.882 240.948C129.302 245.183 127.402 253.95 131.637 260.53C135.873 267.109 144.64 269.01 151.219 264.774Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M149.799 255.729C151.38 252.282 149.867 248.206 146.42 246.625C142.973 245.043 138.896 246.556 137.315 250.003C135.734 253.451 137.247 257.527 140.694 259.108C144.141 260.689 148.217 259.177 149.799 255.729Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M114.828 224.784C127.397 224.784 137.585 214.595 137.585 202.027C137.585 189.459 127.397 179.27 114.828 179.27C102.26 179.27 92.0713 189.459 92.0713 202.027C92.0713 214.595 102.26 224.784 114.828 224.784Z",
    fill: "#28CC9E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M147.364 217.182C152.251 211.055 155.31 203.672 156.188 195.884C157.066 188.096 155.728 180.218 152.327 173.156C148.927 166.094 143.603 160.136 136.966 155.966C130.33 151.796 122.651 149.583 114.814 149.583C106.976 149.583 99.2975 151.796 92.6613 155.966C86.025 160.136 80.7005 166.094 77.3002 173.156C73.8999 180.218 72.5618 188.096 73.4399 195.884C74.3179 203.672 77.3765 211.055 82.2638 217.182H147.364Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M140.294 175.504H88.3119C85.1496 175.504 82.5859 178.068 82.5859 181.23V199.654C82.5859 202.817 85.1496 205.38 88.3119 205.38H140.294C143.456 205.38 146.02 202.817 146.02 199.654V181.23C146.02 178.068 143.456 175.504 140.294 175.504Z",
    fill: "#28CC9E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4463 189.231C90.1338 187.306 91.3867 185.634 93.041 184.434C94.6952 183.233 96.6736 182.56 98.7167 182.504C100.76 182.447 102.772 183.009 104.491 184.116C106.209 185.222 107.553 186.822 108.346 188.706",
    stroke: "#263238",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M120.799 189.231C121.486 187.306 122.739 185.634 124.394 184.434C126.048 183.233 128.026 182.56 130.069 182.504C132.112 182.447 134.125 183.009 135.843 184.116C137.562 185.222 138.906 186.822 139.699 188.706",
    stroke: "#263238",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M109.34 196.154C109.516 197.542 110.192 198.819 111.241 199.744C112.291 200.669 113.642 201.179 115.041 201.179C116.441 201.179 117.792 200.669 118.841 199.744C119.891 198.819 120.567 197.542 120.743 196.154H109.34Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M168.7 198.52C167.545 198.52 166.437 198.061 165.621 197.245C164.804 196.428 164.346 195.321 164.346 194.166V184.261C164.345 183.689 164.457 183.122 164.675 182.593C164.894 182.064 165.214 181.583 165.618 181.178C166.023 180.773 166.503 180.451 167.032 180.232C167.561 180.013 168.127 179.9 168.7 179.9C169.272 179.899 169.839 180.011 170.368 180.23C170.897 180.448 171.378 180.769 171.783 181.173C172.188 181.577 172.509 182.058 172.729 182.586C172.948 183.115 173.061 183.682 173.061 184.254V194.159C173.062 194.732 172.949 195.3 172.731 195.829C172.512 196.359 172.191 196.84 171.785 197.245C171.38 197.65 170.899 197.971 170.37 198.19C169.84 198.409 169.273 198.521 168.7 198.52Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7663 198.52C59.1939 198.521 58.627 198.409 58.0979 198.191C57.5689 197.972 57.0881 197.652 56.683 197.247C56.278 196.843 55.9566 196.363 55.7374 195.834C55.5181 195.305 55.4053 194.739 55.4053 194.166V184.261C55.4044 183.688 55.5165 183.121 55.7354 182.591C55.9542 182.062 56.2754 181.581 56.6805 181.175C57.0857 180.77 57.5668 180.449 58.0963 180.23C58.6258 180.011 59.1933 179.899 59.7663 179.9C60.3381 179.9 60.9042 180.013 61.4325 180.232C61.9607 180.45 62.4407 180.771 62.845 181.175C63.2493 181.58 63.57 182.06 63.7889 182.588C64.0077 183.116 64.1203 183.682 64.1203 184.254V194.159C64.1212 194.732 64.0093 195.298 63.7909 195.828C63.5725 196.357 63.2519 196.837 62.8475 197.242C62.4431 197.647 61.9628 197.969 61.4341 198.188C60.9054 198.407 60.3386 198.52 59.7663 198.52Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7241 153.825C69.8728 159.516 67.8195 166.232 67.8301 173.103V180.299",
    stroke: "#263238",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M156.38 153.853C153.228 149.157 148.969 145.31 143.978 142.65C138.988 139.989 133.419 138.599 127.764 138.6H102.319C96.6712 138.596 91.1094 139.981 86.123 142.632C81.1365 145.283 76.8784 149.12 73.7236 153.804",
    stroke: "#263238",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M162.246 180.299V173.103C162.257 166.245 160.214 159.54 156.38 153.853",
    stroke: "#263238",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3017 172.55H65.4637C62.0848 172.55 59.3457 175.289 59.3457 178.668V198.891C59.3457 202.27 62.0848 205.009 65.4637 205.009H71.3017C74.6806 205.009 77.4197 202.27 77.4197 198.891V178.668C77.4197 175.289 74.6806 172.55 71.3017 172.55Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3068 172.55H67.4658V205.009H69.3068V172.55Z",
    fill: "#28CC9E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M163.506 172.55H157.668C154.289 172.55 151.55 175.289 151.55 178.668V198.891C151.55 202.27 154.289 205.009 157.668 205.009H163.506C166.885 205.009 169.624 202.27 169.624 198.891V178.668C169.624 175.289 166.885 172.55 163.506 172.55Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M161.511 172.55H159.67V205.009H161.511V172.55Z",
    fill: "#28CC9E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M114.975 169.603C118.164 169.604 121.302 168.806 124.103 167.283C126.905 165.759 129.28 163.558 131.012 160.881L134.96 154.77C128.704 151.315 121.664 149.529 114.517 149.584C107.371 149.64 100.359 151.534 94.1572 155.085L100.1 162.463C101.888 164.69 104.152 166.487 106.727 167.723C109.301 168.958 112.12 169.601 114.975 169.603Z",
    fill: "#28CC9E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M115.962 208.404C115.962 208.266 115.92 208.13 115.844 208.015C115.767 207.9 115.657 207.81 115.529 207.757C115.401 207.704 115.261 207.691 115.125 207.718C114.989 207.745 114.864 207.811 114.767 207.909C114.669 208.007 114.602 208.132 114.575 208.268C114.548 208.403 114.562 208.544 114.615 208.672C114.668 208.8 114.758 208.909 114.873 208.986C114.988 209.063 115.123 209.104 115.262 209.104C115.447 209.104 115.625 209.03 115.757 208.899C115.888 208.768 115.962 208.59 115.962 208.404Z",
    fill: "#263238"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M115.962 210.756C115.962 210.618 115.92 210.482 115.844 210.367C115.767 210.252 115.657 210.162 115.529 210.109C115.401 210.056 115.261 210.043 115.125 210.07C114.989 210.097 114.864 210.163 114.767 210.261C114.669 210.359 114.602 210.484 114.575 210.62C114.548 210.755 114.562 210.896 114.615 211.024C114.668 211.152 114.758 211.261 114.873 211.338C114.988 211.415 115.123 211.456 115.262 211.456C115.447 211.456 115.625 211.382 115.757 211.251C115.888 211.12 115.962 210.942 115.962 210.756Z",
    fill: "#263238"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M113.294 210.392C113.422 210.31 113.52 210.188 113.572 210.045C113.624 209.902 113.629 209.746 113.584 209.6C113.54 209.455 113.45 209.327 113.327 209.238C113.203 209.148 113.055 209.101 112.902 209.104C112.775 209.187 112.677 209.309 112.625 209.451C112.572 209.594 112.568 209.75 112.612 209.896C112.657 210.042 112.747 210.169 112.87 210.258C112.993 210.348 113.142 210.395 113.294 210.392Z",
    fill: "#263238"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M117.502 210.392C117.61 210.39 117.716 210.363 117.812 210.313C117.908 210.263 117.992 210.192 118.055 210.104C118.119 210.016 118.161 209.915 118.179 209.808C118.197 209.702 118.19 209.592 118.159 209.488C118.127 209.385 118.072 209.29 117.998 209.211C117.923 209.132 117.832 209.072 117.73 209.035C117.628 208.998 117.519 208.984 117.412 208.997C117.304 209.009 117.201 209.045 117.11 209.104C117.001 209.106 116.895 209.133 116.799 209.183C116.703 209.233 116.62 209.305 116.556 209.392C116.492 209.48 116.45 209.581 116.432 209.688C116.414 209.795 116.421 209.904 116.452 210.008C116.484 210.111 116.539 210.206 116.613 210.285C116.688 210.364 116.779 210.424 116.881 210.461C116.983 210.499 117.092 210.512 117.199 210.5C117.307 210.488 117.411 210.451 117.502 210.392Z",
    fill: "#263238"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M142.8 234.668C133.889 232.659 114.597 231.938 114.597 231.938C109.949 232.085 97.0132 232.638 88.1022 234.675C86.4152 235.058 84.9473 236.091 84.0169 237.55C83.0865 239.008 82.7686 240.775 83.1322 242.466L91.3852 281.078C91.7906 282.95 92.8238 284.628 94.3134 285.832C95.803 287.036 97.6596 287.696 99.5752 287.7H131.39C133.306 287.696 135.162 287.036 136.652 285.832C138.141 284.628 139.175 282.95 139.58 281.078L147.826 242.466C148.188 240.766 147.863 238.992 146.921 237.531C145.98 236.069 144.498 235.04 142.8 234.668Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M138.74 233.926C129.073 232.484 114.618 231.938 114.618 231.938C107.54 232.141 100.479 232.725 93.4639 233.688L102.816 287.7H128.233L138.74 233.926Z",
    fill: "#28CC9E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M122.962 243.677H107.478C104.316 243.677 101.752 246.241 101.752 249.403V256.963C101.752 260.125 104.316 262.689 107.478 262.689H122.962C126.124 262.689 128.688 260.125 128.688 256.963V249.403C128.688 246.241 126.124 243.677 122.962 243.677Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M110.698 251.51H106.337V255.871H110.698V251.51Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M117.397 251.51H113.036V255.871H117.397V251.51Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M124.103 251.51H119.742V255.871H124.103V251.51Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9424 275.492H131.53C132.459 275.492 133.349 275.861 134.005 276.517C134.662 277.173 135.03 278.064 135.03 278.992V322.581H50.4424V278.992C50.4424 278.064 50.8111 277.173 51.4675 276.517C52.1239 275.861 53.0141 275.492 53.9424 275.492Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M135.03 291.158C124.404 293.853 113.498 300.713 93.1774 310.373C73.5774 319.697 57.5334 319.536 50.4424 318.815V322.581H135.03V291.158Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M135.03 319.97H50.4424V322.588H135.03V319.97Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M97.097 299.04C97.097 299.902 96.8412 300.746 96.362 301.463C95.8828 302.18 95.2018 302.739 94.4049 303.069C93.608 303.399 92.7312 303.485 91.8852 303.317C91.0393 303.149 90.2622 302.734 89.6523 302.124C89.0424 301.514 88.6271 300.737 88.4588 299.891C88.2905 299.045 88.3769 298.168 88.707 297.371C89.037 296.574 89.596 295.893 90.3132 295.414C91.0303 294.935 91.8735 294.679 92.736 294.679C93.8926 294.679 95.0018 295.138 95.8197 295.956C96.6375 296.774 97.097 297.883 97.097 299.04Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotBro1);
export default __webpack_public_path__ + "static/media/Chat bot-bro 1.fe5a6d1fbde8795ac85322dbdc9e67f5.svg";
export { ForwardRef as ReactComponent };